export const pageName = {
  jcal: "精彩案例",
  alxq: "案例详情",
  ppdt: "品牌动态",
  rz: "认证",
  azzd: "安装指导",
  by: "保养",
  cjwt: "常见问题",
  bz: "帮助",
  cpzx: "产品中心",
  gsm: "改色膜",
  zbcx: "质保查询",
  jxscx: "经销商查询",
  bjcx: "报价查询",
  jjfa: "解决方案",
  das: "DAS 3D裁膜数据辅助系统",
  zyazry: "加入经销商",
  azpx: "安装培训"
};
export default {
  dictionary: {
    topList: ["质保查询", "经销商查询", "报价查询"],
    navigationList: [
      "关于拓弗勒",
      "产品中心",
      "解决方案",
      "精彩案例",
      "品牌动态",
      "所在地"
    ],
    navigationList2: {
      Product: ["漆面保护膜", "G速膜(汽车窗膜)", "改色膜", "天窗铠甲"],
      Solution: ["培训", "成为经销商", "软件"],
      Case: ["漆面保护膜", "G速膜(汽车窗膜)", "改色膜", "天窗铠甲"],
      Address: []
    },
    navigationList3: {
      "Solution-train": ["培训课程"],
      "Solution-become": ["加入经销商"],
      "Solution-software": ["DAS 3D裁膜数据辅助系统"]
    }
  },
  pageName: pageName,
  About: {
    progress: "TOPS拓弗勒·匠心征程",
    brand: "品牌介绍",
    news: "新闻资讯",

    home: "网站首页",
    backTop: "回到顶部"
  },
  WonderfulCase: {
    title: "精彩案例",
    model: "施工车型",
    product: "施工产品",
    productType: "产品类型",
    productModel: "产品型号",
    productProcess: "产品工艺",
    nextPage: "下一页",
    prevPage: "上一页",
    titleDetail: "精彩案例详情"
  },

  product: {
    productCenter: "产品中心",
    viewDetail: "查看详情",
    paintTitle: "漆面保护膜“GERMAN”标准",
    ppf: "漆面保护膜",
    QA: val => {
      return `质保期限: ${val}年`;
    },
    standard: "标准",
    germany: "德国",
    parameter: "产品参数",
    tableDic: {
      model: "型号",
      visibleLightTransmittance: "可见光 透过率",
      totalSolarBarrier: "太阳能 总阻隔率",
      infraredBlockingRate: "红外线 总阻隔率",
      reflectiveRate: "反光率",
      UVBarrier: "紫外线 阻隔率",
      "5gSignalPassRate": "5G信号 通过率",
      thickness: "厚度",
      warrantyPeriod: "质保年限"
    },
    tableDic2: {
      visibleLightTransmittance: "可见光 透过率",
      totalSolarBarrier: "太阳能      总阻隔率",
      infraredBlockingRate: "红外线 总阻隔率",
      infraredBarrierRatio: "红外线 阻隔率",
      UVBarrier: "紫外线 阻隔率",
      "5gSignalPassRate": "5G信号 通过率",
      thickness: "厚度",
      warrantyPeriod: "质保年限"
    }
  },
  dynamic: {
    hot: "推荐热点",
    refresh: "换一批"
  },
  help: {
    firstName: "名字",
    city: "城市",
    lastName: "姓",
    region: "省(市)",
    companyName: "公司名称",
    country: "国家",
    email: "邮箱",
    zip: "邮编",
    phone: "手机号",
    addressOne: "地址1",
    addressTwo: "地址2",
    requestDetails: "内容",
    submit: "提交",
    resetForm: "重新填写",
    formTitle: "信息表",
    formdes: "必填信息*"
  },
  train: {
    title: "致力于安装质量",
    text:
      "       我们致力于为客户提供TOPPF拓弗产品的优质安装服务，这对您在漆面保护行业的成功至关重要。因此，TOPPF拓弗提供了一套非常全面的安装培训课程，这些课程一直被评为业内最佳课程。",
    text1: "",
    callingText: "请发送邮件至",
    or: "",
    knowMore: "了解更多信息或安排上课。",
    trainingclass: "培训班",
    courseList: [
      {
        id: "course-1",
        title: "培训班",
        content: ["安装培训", "大师级培训", "大师级培训大师"]
      },
      {
        id: "course-2",
        title: "持续时间",
        content: ["四天", "三天", "两天"]
      },
      // {
      //   id: "course-3",
      //   title: "价格",
      //   content: ["€600", "€500", "€400"]
      // }
    ],
    installationTrainingTitle: "安装培训",
    installationTrainingContent:
      "我们在TOPPF拓弗培训中心提供所有课程，该培训中心位于德国和中国上海。 我们的PPF安装培训使新手和高级安装人员受益于每个技能水平的有目的结构的教学大纲。学员将获得个人关注，使他们能够获得必要的技能， 即使是最具挑战性的车辆也能提供高质量， 无故障的安装。",
    installationTrainingContent1:
      "我们还提供有关使用我们的数据辅助系统（DAS）软件和相关硬件的完整说明。 我们将为您提供培训手册，所有必要的材料和工具。 为了确保足够的专业注意力，班级人数通常限于每位教师四名学员。",
    installationTrainingContent2:
      "如果您想了解更多信息，请发送电子邮件至info@topsfilm.com与公司代表协商。",
    internationalTrainingAvailable: "国际培训",
    gcompanyName: "TOPS 拓弗勒德国",
    gadress: "斯瓦特哈勒福赫 28号，慕尼黑，德国",
    gphone: "+49 89 24440 7026",
    gworkTime: "9:00-18:00",
    gdes:
      "TOPS拓弗勒德国总部位于德国慕尼黑的斯瓦特哈勒福赫 28号，为所有地区的客户提供培训。",
    formTitle:
      "了解更多信息<br/>对TOPPF拓弗PPF安装培训有疑问？<br/>填写下面的联系表格："
  },
  joinDealer: {
    formTitle:
      "了解更多信息<br/>对 加入TOPS拓弗勒 经销商有疑问？<br/>填写下面的联系表格：",
    title: "满足客户真正的需求，TOPS拓弗勒是您最值得信赖的选择.",
    content:
      "TOPS拓弗勒致力于引领行业，重新定义公众对高性能保护和精密薄膜安装的需求和期望值。 凭借其在模式设计和软件开发方面的根基，我们致力于提高我们的专业安装人员的盈利能力并最大化回报。我们随时准备通过我们先进的汽车漆面保护膜和各种商业窗膜，油漆保护膜，安装工具，后期护理产品以及业内最全面的培训计划，帮助您的业务提升到行业高尖水平。",
    nmoreInfo: "了解更多信息↓",
    findDealer: "查找经销商门店",

    dealerPhotop: "经销商镜头",
    success: "我们为您取得成功",
    successDes:
      "在TOPS拓弗勒，我们投入巨资帮助我们的专业安装人员家族在实现长期成功的道路上实现其业务目标。",
    advantageTitle: "成为经销商的优势：",
    advantageList: [
      "凭借我们独特的安装程序定位器，在顶级搜索引擎结果中获得高排名。",
      "每天24小时即时连接TOPS拓弗勒的全球客户服务团队，一周七天。",
      "专业的销售专业人员，帮助您在零售和商业中发展业务。",
      "获得品牌授权和营销资源支持，专业培训，共创事业成功。"
    ],
    curx: "成功的关键",
    curxtitle: "无与伦比的训练",
    curxcontent:
      "顶级安装从一套强大的技能开始。在TOPS拓弗勒，我们提供业内最高评级和最全面的专业培训。 经过多年的安装培训，我们的认证计划将为您提供所需的知识储备。",

    curxtitle1: "定制软件",
    curxcontent1:
      " 作为预切套件的创建者和创新者，我们领先的数据辅助系统（DAS）将帮助您以最大的效率在竞争中保持领先地位。 DAS由超过140,000种模式组成，并且不断更新，使您能够为客户提供他们所需要的精确性。"
  },
  distributor: {
    title: "查找授权的TOPS经销商",
    country: "国家",
    select: "--请选择--",
    province: "省",
    city: "城市",
    noresult: "暂无数据",
    query: "查询",
    queryMap: "获取路线"
  },
  bottomNavigation: {
    title: "亚太地区总部",
    adress: "上海市闵行区光华路 689号C3栋 ",
    helpList: [
      {
        text: "找到您附近的TOPS拓弗勒经销商→"
      },
      {
        text: "查询车辆贴膜报价→"
      },
      {
        text: "成为经销商→"
      }
    ]
  },
  warranty: {
    query: "Query",
    warrantyQuery: "质保查询",
    phone: "手机号：",
    enterPhone:"请输入手机号",//Please enter your phone number
    plateNumber: "车牌号：",//
    enterPlateNumber: "请输入车牌号或车架号",//Please enter the license plate number or chassis number
    digitalCertification:"电子质保",
  },
  offer: {
    title: "在下面选择您的车辆，查看可用的TOPPF拓弗漆面保护膜预切割套件。",
    subTitle:"显示的定价为建议施工价。",
    brand: "品牌：",
    model: "车型：",
    filmType: "膜类型：",
    pleaseSelectBrand: "请选择品牌",
    pleaseSelectModel: "请选择车型",
    pleaseSelectFilmType: "请选择膜类型",
    selectAddtoCart: "部位",
    description: "描述",
    information: "信息",
    price: "价格",
    entireVehicle: "全车",
    frontBumper: "前保险杠",
    hood: "发动机盖",
    frontFender: "前叶子板",
    door:"车门",
    roof: "车顶",
    rearFender:"后叶子板",
    tailHood: "后盖",
    rearBumper:"后保险杠",

  }
};



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js